import React, { forwardRef, InputHTMLAttributes, useState } from "react";
import styles from "./MGInputRadioButton.module.css";

export type TMGInputRadioButtonBackground = "light" | "dark" | "brand";
export type TMGInputRadioButtonSize = "xs" | "sm";

export type TMGInputRadioButtonProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "size" | "type"
> & {
  background?: TMGInputRadioButtonBackground;
  dataTestId?: string;
  error?: boolean;
  radioButtonId?: string;
  radioButtonSize?: TMGInputRadioButtonSize;
};

let generatedId = 0;

export const MGInputRadioButton = forwardRef<HTMLInputElement, TMGInputRadioButtonProps>(
  (
    {
      background = "light",
      className,
      dataTestId,
      disabled = false,
      error = false,
      id,
      radioButtonId,
      radioButtonSize = "sm",
      tabIndex,
      ...inputProps
    },
    ref,
  ) => {
    const [internalId] = useState(() => `mg-radio-${++generatedId}`);
    const resolvedId = radioButtonId || id || internalId;

    return (
      <span
        className={`${styles.radio}${className ? ` ${className}` : ""}`}
        data-background={background}
        data-disabled={disabled}
        data-error={error}
        data-size={radioButtonSize}
        data-testid={dataTestId}>
        <input
          {...inputProps}
          ref={ref}
          className={styles.input}
          type="radio"
          id={resolvedId}
          disabled={disabled}
          tabIndex={disabled ? -1 : tabIndex}
        />
        <span className={styles.visual} aria-hidden="true">
          <span className={styles.inner} />
        </span>
      </span>
    );
  },
);

MGInputRadioButton.displayName = "MGInputRadioButton";
